/** API route map: URLS.Controller.EmployeeEnrollment */
export const EmployeeEnrollment = {
      Name: 'EmployeeEnrollment/',
      GetEnrollPlanEmployee: 'get-enroll-plan-employee',
      AddEmployeeBenefitEnrollmentAdjustment: 'add-employee-benefit-enrollment-adjustment',
      GetEmployeeBenefitEnrollmentAdjustment: 'get-employee-benefit-enrollment-adjustment',
      DeleteEmployeeBenefitEnrollmentAdjustment: 'delete-employee-benefit-enrollment-adjustment',
      UpdateEmployeeBenefitEnrollmentAdjustment: 'update-employee-benefit-enrollment-adjustment',
      SearchDeductionCode: 'search-deduction-code',
      AddScheduleDeduction: 'add-employee-schedule-deduction',
      DeleteEmployeeScheduleDeduction: 'delete-employee-schedule-deduction',
      UpdateEmployeeScheduleDeduction: 'update-employee-schedule-deduction',
      GetAllEmployeeScheduleDeduction: 'get-employee-schedule-deduction',
      GetDeductionCodeName: 'get-deduction-code',
      AddEmployeeBenefitEnrollmentRecurringDeduction: 'add-employee-benefit-enrollment-deduction',
      GetEmployeeBenefitEnrollmentRecurringDeduction: 'get-employee-benefit-enrollment-deduction',
      DeleteEmployeeBenefitEnrollmentRecurringDeduction:
        'delete-employee-benefit-enrollment-deduction',
      UpdateEmployeeBenefitEnrollmentRecurringDeduction:
        'update-employee-benefit-enrollment-deduction',
      GetEnrollmentApprovalDetails: 'get-enrollment-approval-details',
};
